import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.fullscreen'
import 'leaflet.fullscreen/Control.FullScreen.css'
import 'leaflet-minimap'
import 'leaflet-minimap/dist/Control.MiniMap.min.css'
import 'leaflet.nauticscale/dist/leaflet.nauticscale.min'
import 'leaflet-easybutton'
import 'leaflet-easybutton/src/easy-button.css'
import 'leaflet-linear-measurement/src/Leaflet.LinearMeasurement'
import 'leaflet-linear-measurement/sass/Leaflet.LinearMeasurement.scss'
import 'leaflet-control-custom'
import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min'
import 'leaflet-groupedlayercontrol/dist/leaflet.groupedlayercontrol.min.css'
import '@/../node_modules_adapted/leaflet-switch-basemap/src/L.switchBasemap'
import '@/../node_modules_adapted/leaflet-switch-basemap/src/L.switchBasemap.css'
// import 'leaflet-sidebar-v2/js/leaflet-sidebar.min'
// import 'leaflet-sidebar-v2/css/leaflet-sidebar.min.css'

export default {
  name: 'BelugaMapControls',
  methods: {
    // toggleWindLayer: function (element) {
    //   alert('test')
    //   // if ('wind_1p00_particles' in widget.layers) {
    //   //   if (element.checked) {
    //   //     if (!widget.map.hasLayer('wind_1p00_particles')) {
    //   //       widget.map.addLayer(widget.layers.wind_1p00_particles)
    //   //     }
    //   //   } else {
    //   //     if (widget.map.hasLayer('wind_1p00_particles')) {
    //   //       widget.map.removeLayer(widget.layers.wind_1p00_particles)
    //   //     }
    //   //   }
    //   // }
    // },
    // toggleCurrentsLayer: function (element) {
    // },
    createCoordinatesViewControl: function () {
      return '<div class="leaflet-control-coordsview-control">' +
        '<div id="coords-nautical" class="leaflet-control-coordsview-nautical">' +
        'Move mouse or tap on map' +
        '</div>' +
        '<div id="coords-decimal" class="leaflet-control-coordsview-decimal text-secondary">' +
        'to display coordinates at cursor' +
        '</div>'
    },
    // createEnvironmentalParametersControl: function (widget) {
    //   return '<div class="leaflet-control-environparams-control d-inline-flex">' +
    //     '<input type="checkbox" id="environparams_control_wind" onclick="toggleWindLayer(this)" class="mr-2">' +
    //     '<div class="leaflet-control-environparams-param mr-2">Wind<br><span class="text-muted"><small>Global, GFS 1.0&deg;</small></span></div>' +
    //     '<input type="checkbox" id="environparams_control_currents" onchange="toggleCurrentsLayer(this)" class="mr-2">' +
    //     '<div class="leaflet-control-environparams-param">Currents<br><span class="text-muted"><small>Global, OSCAR 0.3&deg;</small></span></div>' +
    //     '</div>'
    // },
    createParameterViewControl: function (widget) {
      // Get more information on selected parameter
      let min = 'Min'
      let max = 'Max'
      let cm = 'jet'
      let platformLabel = 'Platform'
      let entityLabel = 'Entity'
      let parameterLabel = 'Parameter'
      let parameterUnit = ''

      if (widget.selectedParameter !== null) {
        platformLabel = widget.platform(Number(widget.selectedParameter[0])).description
        entityLabel = widget.entity(Number(widget.selectedParameter[0]), Number(widget.selectedParameter[1])).label
        const parameter = widget.parameter(Number(widget.selectedParameter[0]), Number(widget.selectedParameter[1]), Number(widget.selectedParameter[2]))
        parameterLabel = parameter.label
        parameterUnit = parameter.unit
        if (widget.selectedParameter.length !== 3) {
          if (Number(parameter.num_precision) > 0) {
            // Round to digits
            min = widget.showDigits(widget.selectedParameter[3], Number(parameter.num_precision))
            max = widget.showDigits(widget.selectedParameter[4], Number(parameter.num_precision))
          } else {
            // Raw display
            min = widget.selectedParameter[3]
            max = widget.selectedParameter[4]
          }
          cm = widget.selectedParameter[5]
        }
      }
      let control = '<div class="leaflet-control-paramview-control">' +
                    '<div class="leaflet-control-paramview-parameter">' +
                    '<strong>' + platformLabel + '</strong>' +
                    ' <span class="text-muted">\u2B9E</span> ' +
                    '<strong>' + entityLabel + '</strong>' +
                    ' <span class="text-muted">\u2B9E</span> ' +
                    '<strong>' + parameterLabel + '</strong>' +
                    '</div>' +
                    '<div class="leaflet-control-paramview-min">' + min + ' ' + parameterUnit + '</div>'

      // Create colormap
      control += '<div class="leaflet-control-paramview-colormap">'
      for (const color of widget.getColormap(cm)) {
        control += '<div class="leaflet-control-paramview-shade" style="background-color: ' + color + '"></div>'
      }
      control += '</div>'

      control += '<div class="leaflet-control-paramview-max">' + max + ' ' + parameterUnit + '</div>' +
                 '</div>'

      return control
    },
    showParameterViewControl: function (widget) {
      if (widget.controls.parameterView !== null) {
        widget.controls.parameterView.options.content = this.createParameterViewControl(widget)
        if (!widget.map.hasLayer(widget.controls.parameterView)) {
          widget.map.addControl(widget.controls.parameterView)
        }
      }
    },
    removeParameterViewControl: function (widget) {
      if (widget.controls.parameterView !== null) {
        widget.map.removeControl(widget.controls.parameterView)
      }
    },
    initControls: function (widget) {
      // Add layer control
      const baseMaps = {
        'Google Hybrid (Google)': widget.layers.google_hybrid,
        'Google Terrain (Google)': widget.layers.google_terrain,
        'OpenStreetMap Mapnik (OSM)': widget.layers.osm_mapnik,
        'OpenStreetMap DE (OSM)': widget.layers.osm_de,
        'OpenStreetMap Light (CartoDB)': widget.layers.osm_cartodb_light,
        'OpenStreetMap Dark (CartoDB)': widget.layers.osm_cartodb_dark,
        'OpenStreetMap Voyager (CartoDB)': widget.layers.osm_cartodb_voyager,
        // 'OpenStreetMap Terrain (Stamen)': widget.layers.osm_stamen_terrain,
        'OpenTopoMap (OSM)': widget.layers.opentopomap,
        'World Imagery (Esri)': widget.layers.esri_worldimagery,
        'Ocean BaseMap (Esri)': widget.layers.esri_oceanbasemap,
        'Bathymetry (GEBCO)': widget.layers.gebco_bathymetry,
        'Bathymetry (EMODnet)': widget.layers.emodnet_bathymetry
      }
      const groupedOverlays = {
        Generic: {
          'Day and night (Global)': widget.layers.day_night,
          'Geographic lines (Global)': widget.layers.geographic_lines,
          'Exclusive Economic Zones (Global, VLIZ)': widget.layers.marineregions_eez
        },
        Campaign: {
          'Ocean Change 2024 Ports (Arved Fuchs)': widget.layers.ocean_change_stations2024,
          'Ocean Change 2024 CTD Casts (Arved Fuchs)': widget.layers.ocean_change_ctdcasts2024,
          'Ocean Change 2024 Eye on Water (Arved Fuchs)': widget.layers.ocean_change_eyeonwater2024,
          'Ocean Change 2025 Ports (Arved Fuchs)': widget.layers.ocean_change_stations2025,
          'Ocean Change 2025 CTD Casts (Arved Fuchs)': widget.layers.ocean_change_ctdcasts2025,
          'Ocean Change 2025 Eye on Water (Arved Fuchs)': widget.layers.ocean_change_eyeonwater2025
          // 'Ocean Change 21/22 Science (GEOMAR)': widget.layers.ocean_change_science
        },
        Ocean: {
          // 'Surface currents (Global, OSCAR 0.3&deg;, ESR)': widget.layers.currents_particles,
          'Bathymetry (Germany, BSH)': widget.layers.bsh_bathymetry,
          'Bathymetric gridlines (Global, ArcGIS)': widget.layers.arcgis_gebco_bathymetric_gridlines,
          'Multibeam Bathymetry Surveys (Global, NCEI)': widget.layers.ncei_noaa,
          // 'Seabed sediments (Germany, BSH)': widget.layers.bsh_sediments,
          'Sea state (Europe, DWD)': widget.layers.dwd_seegang,
          // 'Significant wave height (Global, CMEMS)': widget.layers.cmems_significantwaveheight,
          // 'Sea water velocity (Global, CMEMS)': widget.layers.cmems_seawatervelocity,
          // 'Sea level anomaly (Global, CMEMS)': widget.layers.cmems_sealevelanomaly,
          'Sea level anomaly (West Africa, GEOMAR)': widget.layers.po_sla_eugen_atlantic,
          // 'Sea level anomaly (South America, GEOMAR)': widget.layers.po_sla_eugen_pacific,
          'Sea Surface Temperature (Global, NASA)': widget.layers.gibs_seasurfacetemperature,
          'Sea Surface Temperature (West Africa, GEOMAR)': widget.layers.po_sst,
          'Marine Heat Waves (Global, NOAA)': widget.layers.marine_heat_waves,
          'Sea Ice Concentration (Global, NASA)': widget.layers.gibs_seaiceconcentration
          // 'Chlorophyll A (Global, NASA, MODIS Aqua)': widget.layers.gibs_modis_aqua_chlorophyl_a,
          // 'Chlorophyll A (Global, NASA, MODIS Terra)': widget.layers.gibs_modis_terra_chlorophyl_a
        },
        Atmosphere: {
          'Wind (Global, GFS 1.0&deg;, NOAA)': widget.layers.wind_1p00_particles,
          // 'Wind (Global, GFS 0.25&deg;, NOAA)': widget.layers.wind_0p25_particles,
          // 'Wind (Global, PacIOOS)': widget.layers.pacioos_gfs_wind,
          'Clouds (Global, DWD)': widget.layers.dwd_wolken,
          'Rain radar (Germany, DWD)': widget.layers.dwd_niederschlagsradar
        },
        Navigation: {
          'Warnings Coast (Germany, DWD)': widget.layers.dwd_warnungen_kueste,
          'Warnings Sea (Germany, DWD)': widget.layers.dwd_warnungen_see,
          'See marks (Global, OpenSeaMap)': widget.layers.openseamap
          // 'Ship traffic (Global, MarineTraffic)': widget.layers.marinetraffic
        }
      }
      widget.map.addControl(L.control.groupedLayers(baseMaps, groupedOverlays))

      // Add basemap switcher
      const basemapSwitcher = new L.BasemapsSwitcher([
        {
          layer: widget.layers.osm_cartodb_voyager,
          icon: 'beluga-web/static/icons/controls/basemap_map.png',
          name: 'Map'
        },
        {
          layer: widget.layers.esri_worldimagery,
          icon: 'beluga-web/static/icons/controls/basemap_satellite.png',
          name: 'Satellite'
        },
        {
          layer: widget.layers.emodnet_bathymetry,
          icon: 'beluga-web/static/icons/controls/basemap_bathymetry.png',
          name: 'Bathymetry'
        }
      ], { position: 'bottomright' })

      widget.map.on('baselayerchange', function (e) {
        basemapSwitcher.setActiveMap(e.layer)
      })
      basemapSwitcher.addTo(widget.map)

      // Add fullscreen control
      widget.map.addControl(new L.Control.FullScreen())

      // Add platform lock control
      widget.controls.lockMap = new L.Control.EasyButton({
        states: [{
          stateName: 'lock-enabled',
          icon: '<img src="/beluga-web/static/shapes/crosshairs-enabled.svg" alt="Disable map locking on selected platform" class="control-icon">',
          title: 'Disable map locking on selected platform',
          onClick: function () {
            widget.options.lockMap = false
            this.state('lock-disabled')
          }
        }, {
          stateName: 'lock-disabled',
          icon: '<img src="/beluga-web/static/shapes/crosshairs-disabled.svg" alt="Lock map center on selected platform" class="control-icon">',
          title: 'Lock map center on selected platform',
          onClick: function () {
            widget.options.lockMap = true
            if (widget.selectedPlatform !== 0) {
              widget.centerPlatform(widget, widget.selectedPlatform)
            }
            this.state('lock-enabled')
          }
        }]
      })
      widget.controls.lockMap.addTo(widget.map)

      // Add coordinates view control
      // FIXME: Proper access right handling
      // FIXME: Ocean Race -> Activated coordinates view
      widget.controls.coordinatesView = L.control.custom({
        title: 'Coordinates view',
        position: 'topright',
        content: this.createCoordinatesViewControl(widget),
        classes: 'leaflet-control-coordsview',
        style: {
          position: 'absolute',
          right: '58px',
          'margin-top': '10px'
        }
      })

      L.Control.OceanRaceOrgs = L.Control.extend({
        onAdd: function (map) {
          const img = L.DomUtil.create('img')
          img.src = 'beluga-web/static/logos/oceanrace-orgs-2023.png'
          img.style.width = '25%'
          return img
        },
        onRemove: function (map) {
          // Nothing to do here
        }
      })
      L.control.oceanraceorgs = function (opts) {
        return new L.Control.OceanRaceOrgs(opts)
      }
      widget.controls.oceanRaceOrgs = L.control.oceanraceorgs({ position: 'bottomleft' })

      // Add environmental parameters control
      // widget.controls.environmentalControl = L.control.custom({
      //   title: 'Wind and currents',
      //   position: 'topcenter',
      //   content: this.createEnvironmentalParametersControl(widget),
      //   classes: 'leaflet-control-environparams',
      //   style: {
      //     position: 'absolute',
      //     'margin-top': '10px'
      //   }
      // }).addTo(widget.map)

      // Add ranging tool control
      widget.controls.rangingBearing = new L.Control.EasyButton({
        states: [{
          stateName: 'ranging-disabled',
          icon: '<img src="/beluga-web/static/shapes/ranging-tool-disabled.svg" class="control-icon">',
          title: 'Enable ranging and bearing tool',
          onClick: function () {
            widget.tools.rangingBearing.active = true
            widget.renderRangingTool(widget)
            this.state('ranging-enabled')
          }
        }, {
          icon: '<img src="/beluga-web/static/shapes/ranging-tool-enabled.svg" class="control-icon">',
          stateName: 'ranging-enabled',
          onClick: function () {
            widget.tools.rangingBearing.active = false
            widget.renderRangingTool(widget)
            this.state('ranging-disabled')
          },
          title: 'Disable ranging and bearing tool'
        }]
      })

      // Measurement tool
      const measureToolBtn = new L.Control.LinearMeasurement({
        unitSystem: 'metric',
        color: '#007bff',
        type: 'line'
      })
      measureToolBtn.addTo(widget.map)
      const measureBar = L.easyBar([
        widget.controls.rangingBearing
      ])
      measureBar.addTo(widget.map)

      // Add sidebar
      // widget.controls.sidebar = L.control.sidebar({
      //   autopan: false,
      //   closeButton: false,
      //   container: 'sidebar',
      //   position: 'right'
      // }).addTo(widget.map)

      // Add parameter view control
      widget.controls.parameterView = L.control.custom({
        title: 'Selected parameter view',
        position: 'bottomcenter',
        content: this.createParameterViewControl(widget),
        classes: 'leaflet-control-paramview',
        style: {
          'margin-bottom': '20px'
        }
      })

      // Add nautic / metric scale
      widget.map.addControl(new L.Control.ScaleNautic({
        metric: true,
        imperial: false,
        nautic: true
      }))

      // Add mini map
      // TODO: Switch layer together with main map layer change
      // const miniMapLayer = L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
      //   maxZoom: widget.options.maxZoom,
      //   attribution: '&copy; CartoCDN',
      //   subdomains: 'abcd',
      //   id: 'osm_cartodb_voyager'
      // })
      // widget.map.addControl(new L.Control.MiniMap(miniMapLayer, {
      //   toggleDisplay: true,
      //   width: 100,
      //   height: 100
      // }))
    }
  }
}
